import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { UiProvider } from '../../ui/ui-provider';
import { RouteNavigationProgress } from '../navigation/RouteNavigationProgress';

/**
 * Puts Control inside the theme token scope. Control pages keep their own Tailwind
 * typography and backgrounds - `.forge-root` carries the tokens and hosts kit portals, and
 * the Forge look lives in `.forge-shell`, which this deliberately does not add.
 *
 * Control is light-only: it has no theme toggle and no dark styling of its own, so the
 * attribute is fixed rather than read from useForgeTheme. Wiring Control to the toggle would
 * leave every unconverted Tailwind colour painting light-on-light in dark mode.
 */
export const ControlLayout: React.FC = () => {
  const [portalContainer, setPortalContainer] = useState<HTMLDivElement | null>(null);

  return (
    <div
      className="forge-root"
      data-forge-theme="light"
      data-testid="control-theme-scope"
      ref={setPortalContainer}
    >
      <UiProvider container={portalContainer}>
        <RouteNavigationProgress />
        <Outlet />
      </UiProvider>
    </div>
  );
};
